import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "auto",
        padding: "40px",
        lineHeight: "1.7",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
        Privacy Policy
      </h1>

      <h3>1. Introduction</h3>
      <p>
        This Privacy Policy describes how Cleanup Car Service Pvt Ltd. collects,
        uses, and protects your information when you use our car wash booking
        services.
      </p>

      <hr />

      <h3>2. Information We Collect</h3>

      <p>
        <b>Personal Information</b>
      </p>
      <ul>
        <li>Name</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>Address / service location</li>
      </ul>

      <p>
        <b>Vehicle Information</b>
      </p>
      <ul>
        <li>Car model</li>
        <li>Vehicle number</li>
        <li>Service preferences</li>
      </ul>

      <p>
        <b>Account Information</b>
      </p>
      <ul>
        <li>Login credentials</li>
        <li>Booking history</li>
        <li>Subscription plan details</li>
      </ul>

      <hr />

      <h3>3. How We Use Your Information</h3>
      <p>We use collected data to:</p>
      <ul>
        <li>Create and manage user accounts</li>
        <li>Process bookings and subscriptions</li>
        <li>Provide customer support</li>
        <li>Improve our services</li>
        <li>Send booking confirmations and service reminders</li>
      </ul>

      <hr />

      <h3>4. Payment Information</h3>
      <p>
        Payments are processed through secure third-party payment gateways. We
        do not store sensitive payment information such as credit card numbers.
      </p>

      <hr />

      <h3>5. Data Protection</h3>
      <p>
        We implement reasonable security measures to protect your personal data
        from unauthorized access, misuse, or disclosure.
      </p>

      <hr />

      <h3>6. Sharing Information</h3>
      <p>We do not sell your personal data.</p>
      <p>Information may be shared with:</p>

      <ul>
        <li>Service staff assigned for the booking</li>
        <li>Payment gateway providers</li>
        <li>Legal authorities when required by law</li>
      </ul>

      <hr />

      <h3>7. Cookies and Tracking</h3>
      <p>
        Our website or mobile application may use cookies to improve user
        experience and analyze usage patterns.
      </p>

      <hr />

      <h3>8. User Rights</h3>
      <p>Users may:</p>
      <ul>
        <li>Update their account information</li>
        <li>Request deletion of their account</li>
        <li>Contact us for data-related queries</li>
      </ul>

      <hr />

      <h3>9. Policy Updates</h3>
      <p>
        This Privacy Policy may be updated periodically. Changes will be posted
        on this page.
      </p>

      <hr />

      <h3>10. Contact Us</h3>
      <p>
        <b>Company Name:</b> Cleanup Car Service Pvt Ltd.
      </p>
      <p>
        <b>Email:</b> manoj.cleanup@gmail.com
      </p>
      <p>
        <b>Phone:</b> +91 9426235075
      </p>
    </div>
  );
};

export default PrivacyPolicy;
